import {memo} from 'react';

import type {SVGProps} from 'react';

export const RemoveBuyerIcon = memo(function RemoveBuyerIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g fill="none">
        <g>
          <path
            d="M9.16624 10.2299C11.0546 10.2299 12.5854 8.69912 12.5854 6.81077C12.5854 4.92241 11.0546 3.3916 9.16624 3.3916C7.27788 3.3916 5.74707 4.92241 5.74707 6.81077C5.74707 8.69912 7.27788 10.2299 9.16624 10.2299Z"
            fill="var(--icon-fill-red)"
          />
          <path
            d="M14.9998 14.5257C14.9998 19.3528 3.33398 19.3528 3.33398 14.5257C3.33398 13.6369 4.0544 12.9165 4.94315 12.9165H13.3911C14.2798 12.9165 15.0002 13.6369 14.9998 14.5257Z"
            fill="var(--icon-fill-red)"
          />
          <path
            d="M5.39717 2.14975C5.98509 1.71516 6.71259 1.4585 7.49967 1.4585C9.45551 1.4585 11.0413 3.04433 11.0413 5.00016C11.0413 6.956 9.45551 8.54183 7.49967 8.54183C5.54384 8.54183 3.95801 6.956 3.95801 5.00016"
            stroke="var(--icon-stroke-red)"
            strokeWidth={1.25}
            strokeMiterlimit={5}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7.80301 16.871C4.68426 16.9572 1.45801 15.7089 1.45801 13.1252C1.45801 12.2047 2.20426 11.4585 3.12467 11.4585H9.71592"
            stroke="var(--icon-stroke-red)"
            strokeWidth={1.25}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12.96 11.223C13.562 10.858 14.2633 10.6522 14.9995 10.6667C17.1662 10.6667 18.9579 12.5001 18.9162 14.6251"
            stroke="var(--icon-stroke-red)"
            strokeWidth={1.25}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.8334 17.375C17.1251 18.125 16.0834 18.5417 14.9584 18.5417C12.7917 18.5417 11.0001 16.7083 11.0417 14.5833C11.0417 14.2362 11.0888 13.8987 11.1767 13.5767"
            stroke="var(--icon-stroke-red)"
            strokeWidth={1.25}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M16.375 14.5834H13.625"
            stroke="var(--icon-stroke-red)"
            strokeWidth={1.25}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </svg>
  );
});
